module.exports = __webpack_public_path__ + "static/media/audioFilesSeLowerGradesSound.8c458a1a.mp3";